import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Capture from "@/pages/Capture";
import Reveal from "@/pages/Reveal";
import Timeline from "@/pages/Timeline";
import Group from "@/pages/Group";
import GroupFridge from "@/pages/GroupFridge";
import Cook from "@/pages/Cook";
import Recipes from "@/pages/Recipes";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/capture" element={<Capture />} />
          <Route path="/reveal/:id" element={<Reveal />} />
          <Route path="/timeline" element={<Timeline />} />
          <Route path="/group" element={<Group />} />
          <Route path="/fridge/:code" element={<GroupFridge />} />
          <Route path="/cook" element={<Cook />} />
          <Route path="/recipes/:id" element={<Recipes />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" toastOptions={{ style: { fontFamily: "IBM Plex Sans", borderRadius: 4 } }} />
    </div>
  );
}

export default App;
